/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { bulkCandidateEmailStore } from '../../axios/bulkCandidateEmailStore'
import type {
	BulkCandidateEmailStoreError,
	BulkCandidateEmailStoreRequest,
	BulkCandidateEmailStoreResponse,
} from '../../types/BulkCandidateEmailStore'

export const bulkCandidateEmailStoreMutationKey = () => [{ url: '/candidates/bulk-email' }] as const

export type BulkCandidateEmailStoreMutationKey = ReturnType<typeof bulkCandidateEmailStoreMutationKey>

export type BulkCandidateEmailStoreVariables = {
	data: BulkCandidateEmailStoreRequest
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/BulkCandidateEmailController.php BulkCandidateEmailController::store */
export function useBulkCandidateEmailStore<TContext = unknown>(
	options?: UseMutationOptions<
		BulkCandidateEmailStoreResponse,
		AxiosError<BulkCandidateEmailStoreError>,
		BulkCandidateEmailStoreVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: bulkCandidateEmailStoreMutationKey(),
		mutationFn: ({ data }: BulkCandidateEmailStoreVariables) =>
			bulkCandidateEmailStore(data, config).then(res => res.data),
		...options,
	})
}
